import getValueWithUnit from "lib/getValueWithUnit";
import { currencyUnits } from "lib/units";
import { TransactionItem } from "./types";

export const truncateHash = (hash: string) =>
  `${hash.slice(0, 6)}...${hash.slice(-4)}`;

export const formatValue = (value: string) => {
  return `${getValueWithUnit(value).dp(4).toFormat()} ${currencyUnits.ether}`;
};

export const formatFee = (tx: TransactionItem) => {
  const fee = BigInt(tx.gas_used || 0) * BigInt(tx.gas_price || 0);
  return `${getValueWithUnit(fee.toString()).dp(5).toFormat()} ${currencyUnits.ether}`;
};

export const formatTimeAgo = (timestamp: string | null) => {
  if (!timestamp) {
    return "";
  }
  const seconds = Math.floor(
    (Date.now() - new Date(timestamp).getTime()) / 1000,
  );
  if (seconds < 60) {
    return `${seconds}s ago`;
  }
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m ago`;
  }
  const hours = Math.floor(minutes / 60);
  return `${hours}h ago`;
};
